<template>
    <div class="container">
        <div class="box">
            <h3 class="title reveal-bottom">
                {{ $t("ep.t1") }}
            </h3>
            <p class="text reveal-bottom">
                {{ $t("ep.c1") }}
            </p>
            <div class="img-w reveal-bottom">
                <img
                    style="width:1200px;"
                    :src="
                        lang === 'en_US'
                            ? require('@/assets/img_svg/enterprise_img_2_en.png')
                            : require('@/assets/img_svg/enterprise_img_2_cn.png')
                    "
                    alt="svg"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            lang: localStorage.getItem("lang"),
        };
    },
    mounted() {
        this.$bus.$on("lang", (lang) => (this.lang = lang));
    },
};
</script>
<style scoped>
.container {
    background: #f2f2f2;
    overflow: hidden;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 150px;
}
.text {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 44px;
    margin-top: 41px;
}
.img {
    width: 1180px;
    height: 1037px;
    margin-bottom: 187px;
}
.img-w {
    width: 1180px;
    height: 1037px;
    margin-top: 95px;
    margin-bottom: 187px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Enterprise/Content1.vue